module.exports = __webpack_public_path__ + "static/antd-badge-dynamic-6276bcba12d1c7363267a5fe4ee87d49.gif";